import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as d, normalizeClass as l, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconSkipForwardTen",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.225 2.007A4 4 0 1 0 9.978 6.42a.5.5 0 0 1 .995.106 5 5 0 1 1-1.667-4.278l.004.003.69.622v-.4a.5.5 0 0 1 1 0v1.5a.5.5 0 0 1-.5.5H9a.5.5 0 0 1 0-1h.172l-.53-.476a4 4 0 0 0-2.417-.991ZM5.192 4.038A.5.5 0 0 1 5.5 4.5v3a.5.5 0 1 1-1 0V5.707l-.146.147a.5.5 0 0 1-.707-.707l1-1a.5.5 0 0 1 .545-.109ZM6 5.25a1.25 1.25 0 0 1 2.5 0v1.5a1.25 1.25 0 0 1-2.5 0v-1.5ZM7.25 5a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .5 0v-1.5A.25.25 0 0 0 7.25 5Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function u(e, p, r, f, v, a) {
  return d(), i("svg", {
    "aria-label": r.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--skip-forward-ten"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Skip Forward Ten",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const b = /* @__PURE__ */ o(s, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=skip-forward-ten.js.map
